import React from "react";

export default function NotFound() {
    return (
        <>{/* <h2 className="text-white text-center pt-5">Not Found</h2> */}</>
    );
}
